import { useEffect } from 'react'

const useGtmLoginViewed = () => {
    useEffect(() => {
        dataLayer.push({
            event: 'login',
            step: 'form_view',
            _clear: true,
        })
    }, [])
}

export default useGtmLoginViewed
